import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _726724cc = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _97da5b76 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _a6ff4ac6 = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _0e67e349 = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _311c308e = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _7245004d = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _3b3de500 = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _485df130 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _2d3196aa = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _2960926d = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _296ea9ee = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _298ad8f0 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _2998f071 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _5e46cdae = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _79472ac6 = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _213d585a = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _b8635a9c = () => interopDefault(import('..\\pages\\need-a-card\\insurance-information.vue' /* webpackChunkName: "pages_need-a-card_insurance-information" */))
const _167be51d = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _f70f6e4a = () => interopDefault(import('..\\pages\\need-a-card\\prescriber-information.vue' /* webpackChunkName: "pages_need-a-card_prescriber-information" */))
const _4cf96de2 = () => interopDefault(import('..\\pages\\need-a-card\\select-path.vue' /* webpackChunkName: "pages_need-a-card_select-path" */))
const _467194bc = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _45f4cbd4 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _2ea10696 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _726724cc,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _97da5b76,
    children: [{
      path: "",
      component: _a6ff4ac6,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _0e67e349,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _311c308e,
      name: "have-a-card-success"
    }]
  }, {
    path: "/rejection",
    component: _7245004d,
    name: "rejection"
  }, {
    path: "/thank-you",
    component: _3b3de500,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _485df130,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _2d3196aa,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _2960926d,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _296ea9ee,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _298ad8f0,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _2998f071,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _5e46cdae,
    name: "errors-500"
  }, {
    path: "/need-a-card/eligibility",
    component: _79472ac6,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/insurance",
    component: _213d585a,
    name: "need-a-card-insurance"
  }, {
    path: "/need-a-card/insurance-information",
    component: _b8635a9c,
    name: "need-a-card-insurance-information"
  }, {
    path: "/need-a-card/patient-information",
    component: _167be51d,
    name: "need-a-card-patient-information"
  }, {
    path: "/need-a-card/prescriber-information",
    component: _f70f6e4a,
    name: "need-a-card-prescriber-information"
  }, {
    path: "/need-a-card/select-path",
    component: _4cf96de2,
    name: "need-a-card-select-path"
  }, {
    path: "/need-a-card/success",
    component: _467194bc,
    name: "need-a-card-success"
  }, {
    path: "/patient/patientSearch",
    component: _45f4cbd4,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _2ea10696,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
